import DB from '../../DAL/DB'
import { auth } from '../../Auth'

const projects = new DB.Projects()
const tempProjects = new DB.TempProjects()

export default async function checkFormIntegrity(project, data) {
  let modified = false
  let updatedProject = { ...project, intake: { ...project.intake, sections: { ...project.intake.sections } } }

  // Filter sections immutably
  const validSections = {}
  for (let section in updatedProject.intake.sections) {
    if (updatedProject.intake.order.includes(section)) {
      validSections[section] = updatedProject.intake.sections[section]
    } else {
      modified = true
    }
  }

  // Update project with filtered sections
  updatedProject = {
    ...updatedProject,
    intake: { ...updatedProject.intake, sections: validSections },
  }

  // Update data immutably
  const updatedData = { ...data, intake: updatedProject.intake }

  if (modified) {
    // Update tempProjects with the original project if needed (no mutation)
    await tempProjects.update(project.id, null, updatedProject)
    // Update projects with updated data
    await projects.updatebatch(project.id, null, {
      ...updatedData,
      updatedBy: auth?.sunkaizenUser?.id,
      updatedByName: auth?.sunkaizenUser?.name,
    })
  }

  return { project: updatedProject, data: updatedData }
}